import { z } from "zod";
import { toObjectMap } from "../../utilities/dictionary";
import type { Translatable} from "../translations/translation";
import { translation } from "../translations/translation";

const managedPaymentProviders = ["STRIPE", "SWISH", "PAY_REQUEST"] as const;
const managedPaymentProvidersZodEnum = z.enum(managedPaymentProviders);
type ManagedPaymentProvider = (typeof managedPaymentProviders)[number];

const unmanagedPaymentProviders = ["ON_PREMISE", "FREE", "GIFTCARD"] as const;
const unmanagedPaymentProvidersZodEnum = z.enum(unmanagedPaymentProviders);
type UnmanagedPaymentProvider = (typeof unmanagedPaymentProviders)[number];

const paymentProviders = [
    ...managedPaymentProviders,
    ...unmanagedPaymentProviders,
] as const;
const paymentProvidersZodEnum = z.enum(paymentProviders);
type PaymentProvider = (typeof paymentProviders)[number];
const paymentProvider = toObjectMap<PaymentProvider>([...paymentProviders]);

const paymentProviderZodSchema = paymentProvidersZodEnum;
const managedPaymentProviderZodSchema = managedPaymentProvidersZodEnum;
const unmanagedPaymentProviderZodSchema = unmanagedPaymentProvidersZodEnum;

const paymentProviderDisplayName: Record<PaymentProvider, Translatable> = {
    STRIPE: "Stripe",
    SWISH: "Swish",
    ON_PREMISE: translation({
        sv: "Betala på plats",
        en: "Pay on premise",
    }),
    FREE: translation({
        sv: "Gratis",
        en: "Free",
    }),
    GIFTCARD: translation({
        sv: "Presentkort",
        en: "Gift card",
    }),
    PAY_REQUEST: translation({
        sv: "Betalningsförfrågan",
        en: "Payment request",
    }),
};

export {
    managedPaymentProviders,
    managedPaymentProviderZodSchema,
    paymentProvider,
    paymentProviderDisplayName,
    paymentProviders,
    paymentProviderZodSchema,
    unmanagedPaymentProviders,
    unmanagedPaymentProviderZodSchema,
};
export type {
    ManagedPaymentProvider,
    PaymentProvider,
    UnmanagedPaymentProvider,
};
